/**
 * Utils Module
 * Utility functions for image handling and other helpers
 */

function handleBrokenImages() {
    const createPlaceholderSVG = (width, height) => {
        return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='%23f3f4f6' class='dark:fill-gray-800'/%3E%3Cg transform='translate(${width/2}, ${height/2})'%3E%3Cpath d='M-20,-20 L20,-20 L20,0 L10,10 L-10,10 L-20,0 Z' fill='%23d1d5db' stroke='%239ca3af' stroke-width='2'/%3E%3Ccircle cx='-10' cy='-10' r='3' fill='%23fbbf24'/%3E%3C/g%3E%3C/svg%3E`;
    };

    const attachErrorHandler = (img) => {
        if (img.dataset.errorHandled) return;
        
        img.addEventListener('error', function() {
            this.dataset.errorHandled = 'true';
            const width = this.offsetWidth || 400;
            const height = this.offsetHeight || 300;
            this.src = createPlaceholderSVG(width, height);
            this.alt = this.alt || 'Image not available';
            this.style.opacity = '0.6';
            console.warn('Image failed to load:', this.dataset.originalSrc || this.src);
        });
        
        if (!img.dataset.originalSrc) {
            img.dataset.originalSrc = img.src;
        }
    };

    // Handle existing images
    document.querySelectorAll('img').forEach(attachErrorHandler);

    // Handle dynamically added images
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeName === 'IMG') {
                    attachErrorHandler(node);
                } else if (node.querySelectorAll) {
                    node.querySelectorAll('img:not([data-error-handled])').forEach(attachErrorHandler);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
